import type { FirstPencilManualIncentive } from '../types/firstPencilTypes';

export const isApplicableManualIncentive = (incentive: FirstPencilManualIncentive): boolean =>
    !incentive.deleted && incentive.selected && Boolean(incentive.name.trim()) && incentive.amount > 0;
